
import { defineComponent, PropType } from 'vue'
import type { SubscribedPlanInfo } from '~/mixins/activeUserMixin'
import { FeatureType } from '~/types/features'

export default defineComponent({
  name: 'MonorepoSettings',
  props: {
    isMonorepo: {
      type: Boolean,
      required: true
    },
    togglingMonorepoMode: {
      type: Boolean,
      default: false
    },
    featureGated: {
      type: Boolean,
      default: false
    },
    canChangePlan: {
      type: Boolean,
      default: false
    },
    planInfo: {
      type: Object as PropType<SubscribedPlanInfo>,
      default: () => ({})
    },
    feature: {
      type: String as PropType<FeatureType>,
      default: FeatureType.MONOREPOS
    }
  }
})
